import styled from 'styled-components';

export const ContainerTextArea = styled.div`
  margin: 0px 3px;
`;
